module.exports = __webpack_public_path__ + "static/media/solution-3-sec3.0a0c7eb1.png";